// Where the app may run over plain http: this computer or the local network, as `wrangler dev`
// does. Everywhere else it is served over https, so its cookies are Secure and browsers are told
// to stick to https (Strict-Transport-Security).
//
// A deployment is always reached by a public name with a dot in it (a custom domain or
// workers.dev), so anything else is a development setup: an IP address (IPv4, or IPv6 in
// brackets), a name without a dot (http://devbox:8787) or a name under a suffix that is never
// on the public internet.

const IP_ADDRESS = /^(\d+\.\d+\.\d+\.\d+|\[[\da-f:.]+\])$/i;
const LOCAL_SUFFIX = /(^|\.)(localhost|local|lan|home\.arpa|internal|test)$/i;

/** Whether a URL's hostname (as `new URL(…).hostname` gives it) is on this computer or network. */
export const isLocalHost = (hostname: string) => {
  const host = hostname.replace(/\.$/, "");
  return !host.includes(".") || IP_ADDRESS.test(host) || LOCAL_SUFFIX.test(host);
};

/** One year: how long browsers keep to https once they've seen the app there. */
export const HSTS = "max-age=31536000";

/**
 * The https address of a page opened over plain http on a real web address (a link written with
 * http://), or null when it is already https or runs locally.
 */
export const httpsAddress = (href: string): string | null => {
  const url = new URL(href);
  if (url.protocol !== "http:" || isLocalHost(url.hostname)) return null;
  url.protocol = "https:";
  return url.href;
};
